// CSS Modules - component class name prefix: PageHeader__

<template>
  <div :class="[{ PageHeader__sticky__margin: sticky }, $style.container]">
    <div :class="$style.navMeta">
      <div :class="$style.countrySwitcher">
        <CountrySwitcher
          :config="{
            currentRegion: 'Europa',
            currentCountry: 'Deutschland',
            corporateTitle: 'Corporate Website',
            headquarterTitle: 'Hauptstandort',
            corporateUrl: '#',
            countrySelectPlaceholder: 'Land wählen...',
            websitesTitle: 'Webseiten',
            locationsTitle: 'Standorte'
          }"
        />
      </div>
      <div :class="$style.langSwitcher">
        <LanguageSwitcher :options="langSwitcherOptions" />
      </div>
      <div :class="$style.quickLinks">
        <QuickLinks :quickLinks="quickLinks" />
      </div>
    </div>
    <div :class="[{ PageHeader__sticky: sticky }, $style.navMain]">
      <a :class="$style.homeLink" title="WIKA" href="#">
        <img src="../../assets/logo_wika.svg" alt="WIKA" />
      </a>
      <div :class="$style.desktopNav">
        <MainMenu
          :primaryLinks="primaryLinks"
          :secondaryLinks="secondaryLinks"
        />
      </div>
      <div :class="$style.search">
        <ElasticSearch :config="searchConfig" />
      </div>
      <div :class="$style.mobileNav">
        <MobileMenu
          :primaryLinks="primaryLinks"
          :secondaryLinks="secondaryLinks"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CountrySwitcher from "../CountrySwitcher/CountrySwitcher.vue";
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher.vue";
import MainMenu from "../MainMenu/MainMenu.vue";
import MobileMenu from "../MobileMenu/MobileMenu.vue";
import QuickLinks from "../QuickLinks/QuickLinks.vue";
import ElasticSearch from "../ElasticSearch/ElasticSearch.vue";

export default {
  name: "PageHeader",
  components: {
    CountrySwitcher,
    LanguageSwitcher,
    MainMenu,
    MobileMenu,
    QuickLinks,
    ElasticSearch
  },
  data() {
    return {
      searchConfig: {
        headerSearch: true,
        submitUrl: "",
        placeholder: "Suche"
      },
      langSwitcherOptions: [
        {
          title: "Deutsch",
          img: "demo/de_small.png",
          url: "http://www.google.de"
        },
        {
          title: "Französisch",
          img: "demo/en_small.png",
          url: "http://www.google.fr"
        },
        {
          title: "Liechtenstein",
          img: "demo/en_small.png",
          url: "http://www.google.com"
        }
      ],
      quickLinks: [
        {
          title: "Blog",
          url: "http://blog.wika.de/",
          newWindow: "true",
          icon: "fa-comment-alt"
        },
        {
          title: "WIKA Online Shop",
          url: "https://shop.wika.de/",
          newWindow: "true",
          icon: "fa-shopping-cart"
        }
      ],
      sticky: false,
      stickyPosition: 40,
      primaryLinks: [
        {
          id: "1",
          title: "Produkte",
          isActive: true,
          dividerBeforeTab: 3,
          subNav: [
            {
              id: "1",
              title: "Druck<sup>6</sup>",
              ctas: [
                {
                  mode: "full",
                  colorCode: "#fea800",
                  colorCodeHover: "red",
                  linkText: "Call to Action Button Internal same Window",
                  linkType: "internal",
                  target: "_self",
                  url: "/fs5preview/preview/28/site/EN/current/42/23200"
                },
                {
                  mode: "full",
                  colorCode: "#fea800",
                  colorCodeHover: "#fe8b00",
                  linkText: "Call to Action Button Internal new Window",
                  linkType: "internal",
                  target: "_blank",
                  url: "/fs5preview/preview/28/site/EN/current/42/23200"
                },
                {
                  mode: "half",
                  colorCode: "#fea800",
                  colorCodeHover: "#fe8b00",
                  linkText: "Call to Action Button",
                  linkType: "external",
                  target: "_self",
                  url: "https://www.heise.de"
                },
                {
                  mode: "half",
                  colorCode: "lightGrey",
                  colorCodeHover: "#fe8b00",
                  linkText: "Grey Button",
                  linkType: "external",
                  target: "_blank",
                  url: "https://www.heise.de"
                }
              ],
              subNav: [
                {
                  id: "1",
                  title: "Anzeigen<sup>6</sup>",
                  doubleColumn: true,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer<sup>6</sup>",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "DigitalmanometerDigitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "2",
                  title: "Übertragen",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "3",
                  title: "Schalten",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "4",
                  title: "Weitere Produkte und Zubehör",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                }
              ]
            },
            {
              id: "2",
              title: "Temperatur",
              subNav: [
                {
                  id: "1",
                  title: "Anzeigen",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "2",
                  title: "Übertragen",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "3",
                  title: "Schalten",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "4",
                  title: "Weitere Produkte und Zubehör",
                  doubleColumn: true,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                }
              ]
            },
            {
              id: "3",
              title: "Füllstand",
              subNav: [
                {
                  id: "1",
                  title: "Anzeigen",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "2",
                  title: "Übertragen",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "3",
                  title: "Schalten",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "4",
                  title: "Weitere Produkte und Zubehör",
                  doubleColumn: true,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          id: "2",
          title: "Branchen",
          url: "#",
          subNav: [
            {
              id: "1",
              title: "Druck",
              subNav: [
                {
                  id: "1",
                  title: "Anzeigen",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "2",
                  title: "Übertragen",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "3",
                  title: "Schalten",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "4",
                  title: "Weitere Produkte und Zubehör",
                  doubleColumn: true,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                }
              ]
            },
            {
              id: "2",
              title: "Temperatur",
              subNav: [
                {
                  id: "1",
                  title: "Anzeigen",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "2",
                  title: "Übertragen",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "3",
                  title: "Schalten",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "4",
                  title: "Weitere Produkte und Zubehör",
                  doubleColumn: true,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                }
              ]
            },
            {
              id: "3",
              title: "Füllstand",
              subNav: [
                {
                  id: "1",
                  title: "Anzeigen",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "2",
                  title: "Übertragen",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "3",
                  title: "Schalten",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "4",
                  title: "Weitere Produkte und Zubehör",
                  doubleColumn: true,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                }
              ]
            },
            {
              id: "4",
              title: "Kraft",
              subNav: [
                {
                  id: "1",
                  title: "Anzeigen",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "2",
                  title: "Übertragen",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "3",
                  title: "Schalten",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "4",
                  title: "Weitere Produkte und Zubehör",
                  doubleColumn: true,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          id: "3",
          title: "Service",
          url: "#",
          subNav: [
            {
              id: "1",
              title: "Druck",
              subNav: [
                {
                  id: "1",
                  title: "Anzeigen",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "2",
                  title: "Übertragen",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "3",
                  title: "Schalten",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "4",
                  title: "Weitere Produkte und Zubehör",
                  doubleColumn: true,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                }
              ]
            },
            {
              id: "2",
              title: "Temperatur",
              subNav: [
                {
                  id: "1",
                  title: "Anzeigen",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "2",
                  title: "Übertragen",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "3",
                  title: "Schalten",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "4",
                  title: "Weitere Produkte und Zubehör",
                  doubleColumn: true,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                }
              ]
            },
            {
              id: "3",
              title: "Füllstand",
              subNav: [
                {
                  id: "1",
                  title: "Anzeigen",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "2",
                  title: "Übertragen",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "3",
                  title: "Schalten",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "4",
                  title: "Weitere Produkte und Zubehör",
                  doubleColumn: true,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                }
              ]
            },
            {
              id: "4",
              title: "Kraft",
              subNav: [
                {
                  id: "1",
                  title: "Anzeigen",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "2",
                  title: "Übertragen",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "3",
                  title: "Schalten",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "4",
                  title: "Weitere Produkte und Zubehör",
                  doubleColumn: true,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          id: "4",
          title: "Download",
          url: "#",
          subNav: [
            {
              id: "1",
              title: "Druck",
              url: "https://google.com",
              subNav: [
                {
                  id: "1",
                  title: "Anzeigen",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "2",
                  title: "Übertragen",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "3",
                  title: "Schalten",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "4",
                  title: "Weitere Produkte und Zubehör",
                  doubleColumn: true,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                }
              ]
            },
            {
              id: "2",
              title: "Temperatur",
              url: "https://google.com",
              subNav: [
                {
                  id: "1",
                  title: "Anzeigen",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "2",
                  title: "Übertragen",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "3",
                  title: "Schalten",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "4",
                  title: "Weitere Produkte und Zubehör",
                  doubleColumn: true,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                }
              ]
            },
            {
              id: "3",
              title: "Füllstand",
              subNav: [
                {
                  id: "1",
                  title: "Anzeigen",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "2",
                  title: "Übertragen",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "3",
                  title: "Schalten",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "4",
                  title: "Weitere Produkte und Zubehör",
                  doubleColumn: true,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                }
              ]
            },
            {
              id: "4",
              title: "Kraft",
              subNav: [
                {
                  id: "1",
                  title: "Anzeigen",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "2",
                  title: "Übertragen",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "3",
                  title: "Schalten",
                  doubleColumn: false,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                },
                {
                  id: "4",
                  title: "Weitere Produkte und Zubehör",
                  doubleColumn: true,
                  subNav: [
                    {
                      id: "1",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Manometer",
                      url: "#"
                    },
                    {
                      id: "2",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Digitalmanometer",
                      url: "#"
                    },
                    {
                      id: "3",
                      image:
                        "https://de-de.wika.de/upload/PIC_MM_PressureGauges_de_de_77512.jpg",
                      title: "Drucksensoren",
                      url: "#"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      secondaryLinks: [
        {
          id: "1",
          title: "Unternehmen",
          url: "http://www.google.com",
          subNav: [
            { id: "1", title: "WIKA Gruppe", url: "http://www.google.com" },
            { id: "2", title: "WIKA Deutschland", url: "#" },
            { id: "3", title: "Neuheiten & Messen", url: "#" }
          ]
        },
        {
          id: "2",
          title: "Karriere",
          url: "#",
          subNav: [
            { id: "1", title: "Arbeitgeber", url: "#" },
            { id: "2", title: "Schüler", url: "#" },
            { id: "3", title: "Studenten", url: "#" },
            { id: "4", title: "Berufseinsteiger", url: "#" },
            { id: "5", title: "Berufserfahrene", url: "#" },
            { id: "6", title: "Stellenmarkt", url: "#" },
            { id: "7", title: "Personalmessen", url: "#" }
          ]
        },
        {
          id: "3",
          title: "Kontakt",
          url: "https://www.etecture.de",
          subNav: [
            { id: "1", title: "Ansprechpartner", url: "#" },
            { id: "2", title: "Kontaktformular", url: "#" },
            { id: "3", title: "Ihr Feedback", url: "#" },
            { id: "4", title: "Chatten Sie mit uns", url: "#" },
            { id: "5", title: "Anfahrt", url: "#" },
            { id: "6", title: "WIKA weltweit", url: "#" }
          ]
        },
        {
          id: "4",
          title: "Service",
          url: "https://www.etecture.de"
        }
      ]
    };
  },
  methods: {
    initScroll() {
      window.addEventListener("scroll", this.handleScroll);
    },
    handleScroll() {
      this.sticky = window.pageYOffset > this.stickyPosition;
    }
  },
  created() {
    this.initScroll();
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style module lang="scss">
@import "./PageHeader.scss";
</style>
